import { createSelector } from '@ngrx/store';
import { selectAllTripPassengers } from './entity-store-selectors';

export function selectTripPassengersByTripId(tripId: string) {
  return createSelector(selectAllTripPassengers, (tripPassengers) => {
    return tripPassengers.valueSeq().filter((t) => t.tripId === tripId);
  });
}

export function selectTripPassengersById(passengerId: string) {
  return createSelector(selectAllTripPassengers, (tripPassengers) => {
    return tripPassengers.get(passengerId);
  });
}
